import { ResultData } from "../../service/Shared";
import { AvatarGridRow, DiscussionsActionsMenuGridRow } from "./dataGridCustomTypes";

export type SupportedDataTypes = string | number | boolean | Date | AvatarGridRow | DiscussionsActionsMenuGridRow;
export type SupportedDataTypeNames =
  | "string"
  | "number"
  | "boolean"
  | "Date"
  | "AvatarGridRow"
  | "DiscussionsActionsMenuGridRow";

export enum DataGridColumnCurrency {
  Gbp = "GBP",
  Usd = "USD",
}

export type SortDirection = "asc" | "desc";

export type SortCriteria = {
  key: string;
  direction: SortDirection;
};

export type FilterOperator =
  | "eq"
  | "neq"
  | "gt"
  | "lt"
  | "gte"
  | "lte"
  | "empty"
  | "notEmpty"
  | "startsWith"
  | "endsWith"
  | "contains"
  | "ncontains"
  | "in"
  | "nin";

export type FilterCriteria = {
  key: string;
  operator: FilterOperator;
  value: SupportedDataTypes;
  filterId?: number;
};

export interface CursorChangeProps {
  sorting: SortCriteria[];
  filtering: FilterCriteria[];
  paging: {
    beforeCursor?: string;
    afterCursor?: string;
    pageSize: number;
  };
  /*
    Set when the load is fetching the full result set for a CSV export rather than the rows on screen.
    An export runs alongside an in-flight display load, so handlers must not let it supersede that load
    or write the chart, KPI and loading state that belong to the displayed rows.
  */
  isExport?: boolean;
}

export interface ResultType {
  resultData: ResultData[];
  paging: {
    startCursor: string;
    endCursor: string;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    pageSize: number;
    totalCount: number;
  };
}
